import { atom } from 'recoil';

const FilteredStacks = atom({
  key: 'FilteredStacks',
  default: {},
});

const FilteredRoles = atom({
  key: 'FilteredRoles',
  default: [],
});

const FilteredLevels = atom({
  key: 'FilteredLevels',
  default: [],
});

const FilteredSigungus = atom({
  key: 'FilteredSigungus',
  default: [],
});

const FilterKeyword = atom({
  key: 'FilterKeyword',
  default: '',
});

const FilterPage = atom({
  key: 'FilterPage',
  default: 1,
});

const JobSort = atom({
  key: 'JobSort',
  default: 'default',
});

export {
  FilteredStacks,
  FilteredRoles,
  FilteredLevels,
  FilteredSigungus,
  FilterKeyword,
  FilterPage,
  JobSort,
};
